<div class="header-bar">
  <h1>New Truck</h1>
</div>
<div class="content-container">
  <div class="card card-w-title">
    <form [formGroup]="newTruckForm" (ngSubmit)="save(newTruckForm.value)" autocomplete="off">
      <div class="ui-grid-row" *ngIf="uLevel && uLevel.organisationId">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Region</label></div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="regions"
              [(ngModel)]="selectedRegion"
              (onChange)="onRegionChange($event.value)"
              placeholder="Select region"
              formControlName="regionId"
              autoWidth="false"
              styleClass="form-component"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Depot</label></div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="depots"
              [disabled]="uLevel && uLevel.organisationId && (!selectedRegion || searchingDepots)"
              placeholder="Select depot"
              formControlName="depotId"
              autoWidth="false"
              styleClass="form-component"
            ></p-dropdown>
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Asset Number</label></div>
          <div class="ui-grid-col-8">
            <input
              pInputText
              id="assetNumber"
              formControlName="assetNumber"
              maxlength="20"
              class="form-component"
            />
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Type</label></div>
          <div class="ui-grid-col-8">
            <p-dropdown
              [options]="truckTypes"
              placeholder="Select vehicle type"
              formControlName="typeId"
              autoWidth="false"
              styleClass="form-component"
              required
            ></p-dropdown>
          </div>
        </div>
      </div>

      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Vehicle Capacity, kg</label></div>
          <div class="ui-grid-col-8">
            <input
              type="number"
              pInputText
              name="capacity"
              class="form-component"
              (keydown)="limitCapacity($event)"
              (keyup)="limitCapacity($event)"
              formControlName="capacity"
              min="0"
              max="1000000"
            />
          </div>
        </div>
      </div>
      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Towing Capacity, kg</label></div>
          <div class="ui-grid-col-8">
            <input
              type="number"
              pInputText
              name="capacityTowing"
              class="form-component"
              (keydown)="limitCapacityTowing($event)"
              (keyup)="limitCapacityTowing($event)"
              formControlName="capacityTowing"
              min="0"
              max="1000000"
            />
          </div>
        </div>
      </div>

      <div>
        <div>
          <div class="ui-grid-row">
            <div class="ui-g-6">
              <div class="ui-grid-col-4"><label [ngClass]="{}">Registration Number</label></div>
              <div class="ui-grid-col-8">
                <input
                  pInputText
                  type="text"
                  name="regNumberSearch"
                  [(ngModel)]="regNumberSearch"
                  formControlName="regNumberSearch"
                  class="form-component"
                />
              </div>
            </div>
            <div>
              <button
                pButton
                type="button"
                (click)="SearchVehicle()"
                icon="fa ui-icon-search"
                class="btn-search-vehicle"
                [disabled]="
                  isSearchVehicle ||
                  !(
                    regNumberSearch != null &&
                    regNumberSearch.length > 2 &&
                    regNumberSearch.length <= 8
                  )
                "
              ></button>
              <div class="search-spinner" *ngIf="isSearchVehicle">
                <img src="assets/images/loader.gif" alt="Loading" width="35" height="35" />
              </div>
              <button
                pButton
                type="button"
                label="No Registration"
                class="btn-no-reg"
                (click)="NoRegistration()"
                [disabled]="isSearchVehicle"
              ></button>
            </div>
          </div>
        </div>

        <h2 *ngIf="isShowSearchManual">Manual Entry</h2>
        <h2 *ngIf="isShowVehicleDetail && !isShowSearchManual">Edit Truck Details</h2>

        <div
          formGroupName="vehicleInfo"
          *ngIf="vehicle && (isShowVehicleDetail || isShowSearchManual)"
        >
          <div class="ui-grid-row">
            <div class="ui-g-6">
              <div class="ui-grid-col-4"><label>Registration Number</label></div>
              <div class="ui-grid-col-8">
                <input
                  type="text"
                  name="registration"
                  pInputText
                  [(ngModel)]="vehicle.registration"
                  formControlName="registration"
                  maxlength="8"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6">
              <div class="ui-grid-col-4"><label>Make</label></div>
              <div class="ui-grid-col-8">
                <input
                  type="text"
                  name="make"
                  pInputText
                  [(ngModel)]="vehicle.make"
                  formControlName="make"
                  maxlength="100"
                  class="form-component"
                />
              </div>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-g-6">
              <div class="ui-grid-col-4"><label>Model</label></div>
              <div class="ui-grid-col-8">
                <input
                  type="text"
                  name="model"
                  pInputText
                  [(ngModel)]="vehicle.model"
                  formControlName="model"
                  maxlength="100"
                  class="form-component"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-grid-row">
        <div class="ui-g-6">
          <div class="ui-grid-col-4"><label [ngClass]="{}">Description</label></div>
          <div class="ui-grid-col-8">
            <textarea
              pInputTextArea
              rows="3"
              style="width: 100%"
              id="description"
              formControlName="description"
              maxlength="100"
              class="form-component"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="footerPanel ui-grid-row">
        <button
          type="button"
          class="btn-to-right"
          [routerLink]="['../trucks']"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
        ></button>
        <button
          type="submit"
          class="green-btn btn-to-right"
          pButton
          icon="fa ui-icon-check"
          label="Save"
          [disabled]="!pageValidate()"
        ></button>
      </div>
    </form>
  </div>
</div>
